import React from 'react';
import { Check, Clock, XCircle, Shield, Star } from 'lucide-react';

export const VerificationBadge = ({ status, size = 'default' }) => {
  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    default: 'px-3 py-1 text-sm',
    large: 'px-4 py-1.5 text-base',
  };

  const iconSize = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5',
  };

  if (status === 'verified') {
    return (
      <span className={`badge-verified ${sizeClasses[size]}`} data-testid="badge-verified">
        <Shield className={iconSize[size]} />
        <span>AfCFTA Verified</span>
      </span>
    );
  }

  if (status === 'pending') {
    return (
      <span className={`badge-pending ${sizeClasses[size]}`} data-testid="badge-pending">
        <Clock className={iconSize[size]} />
        <span>Verification Pending</span>
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1.5 ${sizeClasses[size]} bg-red-50 text-red-700 border border-red-200 rounded-full font-medium`} data-testid="badge-unverified">
      <XCircle className={iconSize[size]} />
      <span>Not Verified</span>
    </span>
  );
};

export const AfCFTABadge = ({ eligible, size = 'default' }) => {
  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    default: 'px-3 py-1 text-sm',
    large: 'px-4 py-1.5 text-base',
  };

  const iconSize = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5',
  };

  if (eligible) {
    return (
      <span className={`badge-afcfta ${sizeClasses[size]}`} data-testid="badge-afcfta-eligible">
        <Check className={iconSize[size]} />
        <span>AfCFTA Eligible</span>
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1.5 ${sizeClasses[size]} bg-gray-50 text-gray-600 border border-gray-200 rounded-full font-medium`} data-testid="badge-afcfta-pending">
      <Clock className={iconSize[size]} />
      <span>Check Eligibility</span>
    </span>
  );
};

export const RatingBadge = ({ rating, reviews }) => {
  return (
    <span className="inline-flex items-center gap-1.5 text-sm" data-testid="rating-badge">
      <Star className="w-4 h-4 text-tradeGold fill-tradeGold" />
      <span className="font-medium text-charcoal">{rating.toFixed(1)}</span>
      {reviews && <span className="text-gray-500">({reviews})</span>}
    </span>
  );
};

export default VerificationBadge;
